module.exports = __webpack_public_path__ + "static/medical_cross_gradient-e14dc921c3da5c276b0f3983ed284d02.png";